import { IconButton, CircularProgress } from '@mui/material';
import React, { forwardRef } from 'react';
import type { IconButtonProps } from '@mui/material';

interface LoadingIconButtonProps extends IconButtonProps {
  isLoading: boolean;
}

export interface LoadingIconButtonRef {
  setLoading: (loading: boolean) => void;
}

const LoadingIconButton = forwardRef<HTMLButtonElement, LoadingIconButtonProps>(
  function LoadingIconButton({ isLoading, disabled, children, ...props }, ref) {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
      if (!isLoading && !(disabled ?? false)) {
        props.onClick?.(event);
      }
    };

    return (
      <IconButton
        ref={ref}
        disabled={isLoading || disabled}
        {...props}
        onClick={handleClick}>
        {isLoading ? <CircularProgress size={24} /> : children}
      </IconButton>
    );
  }
);

export default LoadingIconButton;
